import { useMutation, useQueryClient } from "react-query";
import { gql } from "graphql-request";
import { IUser } from "@sso/users/contracts";
import { useSsoUrl } from "@common/hooks/useSsoUrl";

export function useUpdateUser(fetchData: any) {
  const queryClient = useQueryClient();
  const { request } = useSsoUrl();
  return useMutation(async (variables: any) => {
    if (variables.newEmail === fetchData.email) {
      delete variables.newEmail;
    }
    if (variables.newMobileNumber === fetchData.mobileNumber) {
      delete variables.newMobileNumber;
    }
    const { updateUser } = await request(
      gql`
        mutation (
          $uuid: ID!
          $identity: String
          $newEmail: String
          $name: String
          $newMobileNumber: String
        ) {
          updateUser(
            uuid: $uuid
            newIdentity: $identity
            newEmail: $newEmail
            newName: $name
            newPhoneNumber: $newMobileNumber
          ) {
            id
            uuid
            email
            status
            name
            identity
            mobileNumber
            profiles {
              role
              identity
            }
          }
        }
      `,
      {
        id: variables.id,
        uuid: variables.uuid,
        newEmail: variables.newEmail,
        name: variables.name,
        identity: variables.identity,
        newMobileNumber: variables.newMobileNumber,
      }
    );
    await queryClient.invalidateQueries(`user:${variables.uuid}`);
    return updateUser as IUser;
  });
}
